import axiosInstance from '@/shared/api/axios';
import type {
  ApiParcelsProductsGetItem,
  ApiParcelsProductsGetResponse,
  ApiParcelsProductsPostBody,
} from '@/shared/types/api/parcels-products';

export const apiParcelsProductsGet = async (
  parcelId: string,
): Promise<ApiParcelsProductsGetResponse> => {
  const { data } = await axiosInstance.get<ApiParcelsProductsGetResponse>(
    `/parcels/${parcelId}/products`,
  );
  return data;
};

export const apiParcelsProductsPost = async (
  parcelId: string,
  body: ApiParcelsProductsPostBody,
): Promise<ApiParcelsProductsGetItem> => {
  const { data } = await axiosInstance.post<ApiParcelsProductsGetItem>(
    `/parcels/${parcelId}/products`,
    body,
  );
  return data;
};

export const apiParcelsProductsPut = async (
  parcelId: string,
  productId: string,
  body: ApiParcelsProductsPostBody,
): Promise<ApiParcelsProductsGetItem> => {
  const { data } = await axiosInstance.put<ApiParcelsProductsGetItem>(
    `/parcels/${parcelId}/products/${productId}`,
    body,
  );
  return data;
};

export const apiParcelsProductsDelete = async (
  parcelId: string,
  productId: string,
): Promise<void> => {
  await axiosInstance.delete(`/parcels/${parcelId}/products/${productId}`);
};
